// @flow

import React from 'react';
import PropTypes from "prop-types";
import T from './T';

const propTypes = {
	inline: PropTypes.bool,
	name: PropTypes.string,
	id: PropTypes.string,
	value: PropTypes.any,
	checked: PropTypes.bool,
	/**
	 * onClick(onClickParam, value);
	 */
	onClick: PropTypes.func,
	onClickParam: PropTypes.any
};

const defaultProps = {
};

class Tradio extends T {
	constructor(props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}
	
	onChange(e) {
		// e.preventDefault();
		if (this.props.onClick) this.props.onClick(this.props.onClickParam, this.props.value);
	}
	
	render() {
		let className = '';
		if (this.props.inline) className="radio-inline";
		return (<label className={className}><input type="radio" name={this.props.name} checked={this.props.checked} value={this.props.value == null ? "" : this.props.value} onChange={this.onChange}/>{" "}{this.trans(this.props.children)}</label>);
	}
}

Tradio.propTypes = propTypes;
Tradio.defaultProps = defaultProps;

export default Tradio;
